//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _cloneDeep from 'lodash/cloneDeep';
import configStore from '@/store/modules/configStore';
import agreeShelfDataMixin from '@/components/upload/dialogs/agreeShelfDataMixin';

const defaultEnquiryAttachmentTemplate = {
    name: '',
    description: null,
    public: false,
    agree21ShelfId: null,
    agree21Comment: null,
    agree21FormId: null,
    agree21FormName: null,
};

export default {
    mixins: [agreeShelfDataMixin],
    props: {
        enquiryAttachment: {
            type: Object,
            default: () => ({ ...defaultEnquiryAttachmentTemplate }),
        },
        type: {
            type: String,
            default: 'create',
            validator: (value) => ['create', 'edit'].indexOf(value) !== -1,
        },
    },
    data() {
        return {
            enquiryAttachmentModel: {
                ...defaultEnquiryAttachmentTemplate,
                ..._cloneDeep(this.enquiryAttachment),
            },
            file: null,
            shelfIdOptions: [],
            commentOptions: [],
        };
    },
    computed: {
        headline() {
            let type = '';
            switch (this.type) {
                case 'edit':
                    type = 'bearbeiten';
                    break;
                case 'create':
                default:
                    type = 'anlegen';
                    break;
            }

            return `Bankdokument ${type}`;
        },
        buttonLabel() {
            switch (this.type) {
                case 'edit':
                    return 'Speichern';
                case 'create':
                default:
                    return 'Anlegen';
            }
        },
        ...configStore.mapState({
            config: configStore.STATE.CONFIG,
        }),
    },
    mounted() {
        this.initShelfData(
            this.enquiryAttachment.agree21ShelfId && this.enquiryAttachment.agree21Comment
                ? `${this.enquiryAttachment.agree21ShelfId}-${this.enquiryAttachment.agree21Comment}`
                : null
        );
    },
    methods: {
        onShelfDataUpdate(id, comment) {
            this.enquiryAttachmentModel.agree21ShelfId = id;
            this.enquiryAttachmentModel.agree21Comment = comment;
        },
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        async ok() {
            const isValid = await this.$refs.form.validate(true);
            if (!isValid) {
                return;
            }

            this.$emit('ok', {
                enquiryAttachment: this.enquiryAttachmentModel,
                file: this.file,
            });
            this.hide();
        },
        cancel() {
            this.hide();
        },
    },
};
